import { AdminPage } from '@structura/admin'

export default function Admin() {
  return <AdminPage appMaterial="concrete" />
}
